import { useCallback } from 'react'
import { useRefresh } from 'react-admin'

// Switches the active organization: stores the override used by httpClient,
// notifies listeners (Menu) and reloads the current view.
const useSwitchOrganization = () => {
  const refresh = useRefresh()

  return useCallback((orgId: string, orgName: string) => {
    localStorage.setItem('org_id_override', orgId)
    localStorage.setItem('org_name_override', orgName)
    window.dispatchEvent(new Event('orgChange'))
    refresh()
  }, [refresh])
}

export default useSwitchOrganization
